import React from 'react';
import Grid from '../Grid';
import {
  Section04_Styled,
  Article,
  TextBlock,
  Title,
  Description,
  Figure,
  CategoryTitle
} from './styled';

const Section04 = () => {
  return (
    <Section04_Styled>
      <Grid>
        <Article>
          <TextBlock>
            <CategoryTitle>FEATURES</CategoryTitle>
            <Title>Scopes and Granular Permissions</Title>
            <Description>
              Easily control internal and external clients’ access levels to your API with highly
              granular permissions.
            </Description>
            <ul className="scopeList">
              <li key="1">Application Backends</li>
              <li key="2">Command Line Interfaces</li>
              <li key="3">Other Processes</li>
            </ul>
          </TextBlock>
          <Figure>
            <img
              className="my-api"
              src="https://cdn.auth0.com/website/machine-to-machine/images/features/my-api-v2.svg"
              alt="My API"
            />
          </Figure>
        </Article>
        <Article>
          <TextBlock className="desktop-swap">
            <Title>Standards-based Security</Title>
            <Description>
              Rest easy knowing your API is protected with open standards through the use of the
              OAuth2 Client Credentials Grant flow for secure communications.
            </Description>
          </TextBlock>
          <Figure className="desktop-swap">
            <img
              src="https://cdn.auth0.com/website/machine-to-machine/images/features/oauth-graphic-v1.svg"
              alt="OAUTH2"
            />
          </Figure>
        </Article>
      </Grid>
    </Section04_Styled>
  );
};

export default Section04;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-04/Section-04.js